import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m13.773 17.228.644.03c.41.029.79-.269.848-.686.117-.595.03-.952.03-.952 1.258-.417 1.96-1.46 2.34-2.561.79-2.233.146-4.556-1.521-6.224-1.727-1.786-4.448-1.727-6.145-.833-1.55.804-2.809 2.412-3.014 4.168-.35 3.306 1.23 4.675 2.692 5.211 0 0-.205.447-.205 1.102 0 .476.38.893.878.893h.585s-.38.745 0 2.383c.176.714 2.722 2.173 3.512.178s-3.16-1.34-2.224 1.965"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4 10.14h1.317M6 4l1.024 1.042M12.632 2.124v1.495M18 5.28l.644-.64.643-.64M19.479 9.962H21"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const BulbIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
